import { DateTime } from 'luxon'

import { AverageLengthStatsResponse } from '../dashboard-page/AverageLengthReport'
import { BasicStatsResponse } from '../dashboard-page/BasicStats'
import { CustomerValueAndChurnReportResponse } from '../dashboard-page/CustomerValueAndChurnReport'
import { RecentActivityResponse } from '../dashboard-page/RecentActivity'
import { SellingPlanGroup } from '../selling-plans-index-page/api'
import { SubscriptionListResponse } from '../subscriptions-index-page/api'
import { SubscriptionContractSubscriptionStatus } from './api'
import { GQLPaginator } from './gql-models-common'
import { UiProps } from './SystemData'

export const uiPropsNewUserOverwrites = {
  getting_started_card_step: 'create-selling-plan',
} as UiProps

export const sellingPlanGroupsEmptyData: GQLPaginator<SellingPlanGroup> = {
  nodes: [],
  page: { hasNextPage: false, hasPreviousPage: false, firstCursor: null, lastCursor: null },
}

export const subscriptionListEmptyData: SubscriptionListResponse = {
  paginator: {
    last_page: 1,
    total: 0,
    current_page: 1,
    data: [],
  },
  bulkActions: [],
}

export const averageLengthStatsEmptyData: AverageLengthStatsResponse = {
  averageLength: { avg: null, count: 0 },
  averageLengthForChurn: { avg: null, count: 0 },
}

export const basicStatsEmptyData: BasicStatsResponse = {
  totalSubscriptions: 0,
  subscriptionCountByStatus: {
    [SubscriptionContractSubscriptionStatus.Active]: 0,
    [SubscriptionContractSubscriptionStatus.Paused]: 0,
    [SubscriptionContractSubscriptionStatus.Cancelled]: 0,
    [SubscriptionContractSubscriptionStatus.Expired]: 0,
    [SubscriptionContractSubscriptionStatus.Failed]: 0,
  },
  totalOrders: 0,
  totalCustomers: 0,
  activeCustomers: 0,
}

export const churnRateReportEmptyData: CustomerValueAndChurnReportResponse = {
  churnRates: {
    categories: [],
    series: [{ data: [], name: '' }],
    total: 0,
  },
  avgMonthlyCustomerValue: { avgMonthlyValue: 0, customersCount: 0, subscriptionsCount: 0 },
}

export const recentActivityEmptyData: RecentActivityResponse = {
  newSubscriptions: {
    categories: [],
    series: [],
    total: 0,
  },
  finishedSubscriptions: {
    categories: [],
    series: [],
    total: 0,
  },
  newOrders: {
    categories: [],
    series: [],
    total: 0,
  },
  revenue: {
    categories: [],
    series: [],
    total: 0,
  },
  revenuePerSubscription: 0,
  revenuePerOrder: 0,
}

export const shopDataNewUserOverwrites = {
  shop_owner: 'PayWhirl Test 1000',
  email: 'paywhirl-test-1000@paywhirl.com',
  plan_display_name: null,
  myshopify_domain: 'paywhirl-test-1000.myshopify.com',
  name: 'PayWhirl Test 1000',
  installed_shopwhirl_at: DateTime.now().toUnixInteger(),
}
